import React from "react";

function TechStack({ techStacks = [] }) {
  return (
    <section className="py-12 text-center">
      <h2 className="text-3xl font-bold dark:text-white">My Tech Stack</h2>
      <div className="mt-8 flex justify-center space-x-6 items-center flex-wrap gap-4">
        {techStacks.map((tech, index) => (
          <div key={index} className="text-center">
            <img 
              src={tech.icon} 
              alt={`${tech.name} technology icon`} 
              className="w-28 mx-auto" 
              loading="lazy"
              width="112"
              height="112"
            />
            <p className="mt-2 dark:text-gray-300">{tech.name}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default TechStack;
